var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRounded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.5894C0 9.54372 8.95431 0.589417 20 0.589417C31.0457 0.589417 40 9.54372 40 20.5894C40 31.6351 31.0457 40.5894 20 40.5894C8.95431 40.5894 0 31.6351 0 20.5894Z",
    fill: "#E2E5EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8284 22.761V11.5894H17.8284V22.7611L13.8284 18.761L11 21.5895L19.8284 30.4179L28.6569 21.5895L25.8284 18.761L21.8284 22.761Z",
    fill: "#1A1E23"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRounded);
export default __webpack_public_path__ + "static/media/arrow-rounded.a269b49fe23f67c498c5a2dda3bcd022.svg";
export { ForwardRef as ReactComponent };